import gql from 'graphql-tag';

export const updateFoundationFinanceMutation = gql`
  mutation updateFoundationFinance(
    $financeInfo: UpdateFoundationFinanceInput!
  ) {
    updateFoundationFinance(input: $financeInfo) {
      foundationFinance {
        name
        internationalAddress
        phone
        emailFrom
        website
        emailAddress
        city
        country
        state
        postalCode
        netSuiteClass
        department
        incomeGlAccount
        deferredRevenueAccount
        jobCode
        projectCode
        subsidiaryId
      }
    }
  }
`;
